import { AmplitudeProperties } from '../types';
import {
  tealiumLink,
  AmplitudeEventTealium,
  AmplitudeUserTealium,
} from '../utils/tealium';

export function amplitudeEvent(
  label: string,
  properties: AmplitudeProperties,
): void {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (window && window._DATADOG_SYNTHETICS_BROWSER) {
    return;
  }
  tealiumLink(amplitudeEventTealiumPayload(label, properties));
}

export function amplitudeUserEvent(
  set: AmplitudeProperties,
  setOnce: AmplitudeProperties,
): void {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (window && window._DATADOG_SYNTHETICS_BROWSER) {
    return;
  }
  tealiumLink(amplitudeUserTealiumPayload(set, setOnce));
}

export function amplitudeEventTealiumPayload(
  label: string,
  properties?: AmplitudeProperties,
): AmplitudeEventTealium {
  return {
    amplitude_event_label: label,
    amplitude_event_properties: properties,
  };
}

export function amplitudeUserTealiumPayload(
  set?: AmplitudeProperties,
  setOnce?: AmplitudeProperties,
): AmplitudeUserTealium {
  return {
    amplitude_user_properties: set,
    amplitude_user_properties_setOnce: setOnce,
  };
}
